import React from 'react';

export default function TuitionAndFeesModalContent() {
  return (
    <>
      <p>
        We display the average tuition and fees for an undergraduate student
        that is reported by the school to the Department of Education. These
        values might not be the same for all students at an institution.
      </p>
      <p>
        <a href="https://www.benefits.va.gov/gibill/comparison_tool/about_this_tool.asp#tuition_fees_input">
          Learn more about the tuition and fees displayed in the GI Bill
          Comparison Tool
        </a>
      </p>
    </>
  );
}
